import { useMemo } from 'react';
import BinIcon from '../../../../components/icon/Icon';
import { ACCOUNT_TYPES } from '../../../../app/appConstants';
import { useLangContext } from '../../../../providers/LangProvider/LangProviderContext';
import { useSelector } from 'react-redux';
import { getUserHasLiveAccount, getUserSelectedAccountCode } from '../../../../app/appSelectors';
import parseAccountName from '../../../../utils/parseAccountName';
import { Button } from 'react-bootstrap';
import { MobileAccountBoxButtonsStyled } from './styled/MobileAccountBoxButtonsBlockStyled';
import useMobileAccountBoxButtonsHandlers from "../useMobileAccountBoxButtonsHandlers";

function MobileAccountBoxButtonsBlock() {
    const { getLangPath } = useLangContext();
    const hasLiveAccount = useSelector(getUserHasLiveAccount);
    const accountCode = useSelector(getUserSelectedAccountCode);
    const accountType = useMemo(() => {
        return parseAccountName(accountCode)?.type;
    }, [accountCode]);

    const {
        handleWithdrawButtonClick,
        handleDepositButtonClick,
        handleRefillButtonClick,
        handleHistoryButtonClick,
    } = useMobileAccountBoxButtonsHandlers();

    return (
        <MobileAccountBoxButtonsStyled>
            {
                hasLiveAccount && <>
                    {
                        accountType === ACCOUNT_TYPES.LIVE
                            ? <>
                                <Button variant={'secondary'} size={'m14'} onClick={handleWithdrawButtonClick}>
                                    <BinIcon name={'IcWithdraw'}/>
                                    <span>{getLangPath('lite_version.home.withdraw')}</span>
                                </Button>
                                <Button variant={'secondary'} size={'m14'} onClick={handleDepositButtonClick}>
                                    <BinIcon name={'IcPlusCircle'}/>
                                    <span>{getLangPath('lite_version.home.top_up')}</span>
                                </Button>
                            </>
                            : <Button variant={'secondary'} size={'m14'} onClick={handleRefillButtonClick}>
                                <BinIcon name={'IcRebuy'}/>
                                <span>{getLangPath('lite_version.home.refill')}</span>
                            </Button>
                    }
                </>
            }
            <Button variant={'secondary'} size={'m14'} onClick={handleHistoryButtonClick}>
                <BinIcon name={'IcClock'}/>
                <span>{getLangPath('lite_version.home.history')}</span>
            </Button>
        </MobileAccountBoxButtonsStyled>
    );
}

export default MobileAccountBoxButtonsBlock;
